import { useNavigate } from "react-router";
import { getFullDate } from "../../../../misc/misc";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import "./SingleDesignDesktop.css";
import ReactCountryFlag from "react-country-flag";
import { countryMap } from "../../../../utils/constants";
import ShareButtonDesktopGreen from "../../../../components/Buttons/ShareButtonDesktopGreen/ShareButtonDesktopGreen";
import VoteBtn from "../../../../components/Buttons/VoteBtn/VoteBtn";

const SingleDesignDesktop = ({
  changeDesign,
  design,
  likes,
  handleDownload,
  vote,
  onClickDeleteDesign,
  shareUrl,
  userName,
  leftArrow,
  rightArrow,
  userIcon,
  calendarIcon,
  downloadIcon,
  checkIcon,
  user,
  currentIndex,
  designsCount,
  locationData,
  voteBtnState,
  onClickVote,
  onChangeEmail,
  email,
  deleteBtnText
}) => {
  const navigate = useNavigate();
  const noTitle = `${locationData?.location} Design - ${currentIndex}`
 
  return (
    <div className="desktop_design_page_wrapper">
      <div className="pin_page_heading">
        <div className="titles_wrapper_main">
          <div className="title_small">CoTown</div>
          <div className="title_large">
            <span className="title_word_background_line_wrapper">
              <span className="title_word_background_line"></span>
              DESIGN
            </span>
            {" " + "SHOWCASE"}
          </div>
        </div>
      </div>
      <div className="design_page_content_desk">
        <div className="design_image_desk_left">
          <img
            className="single_design_image_desk"
            src={design.image}
            alt="Thumbnail"
          />
          <div className="buttons_lower_wrapper_desk">
            <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
              <button
                className="download_btn_desk"
                onClick={handleDownload}
              >
                <img src={downloadIcon} alt="Download Icon" />
              </button>

              <ShareButtonDesktopGreen facebookUrl={shareUrl}></ShareButtonDesktopGreen>
             
            </div>

            <div className="design_nav_buttons_desk">
              <div
                className="back_btn_desk"
                onClick={() => navigate(`/${locationData?.city}/${design.pin_id}`)}
              >
                &#60; Back to Gallery
              </div>
              <div className="vertical_line_nav_buttons_desk"></div>
              <div className="design_change">
                <button
                  onClick={() => changeDesign("prev")}
                  className="design_back"
                >
                  <img src={rightArrow} />
                </button>
                <span className="mx-5 design_index_desk"> {currentIndex} of {designsCount} </span>
                <button
                  onClick={() => changeDesign("next")}
                  className="design_fore"
                >
                  <img src={leftArrow} />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="design_content_desk_right">
          <div className="upper_container">
            <div className="design_description_desk">
              <div className="design_location_desk">
                <p className="country_desk aligned_text">
                <ReactCountryFlag
                  countryCode={countryMap.get(locationData?.country)}
                  svg
                  style={{ width: '32px', height: '20px' }}
                  title={locationData?.country}
                  />
                  {locationData?.country}
                  </p>
                <p className="location_desk">{locationData?.location + ', ' +  locationData?.city }</p>
              </div>
              <div className="design_creation_desk">
                <div className="user_name aligned_text">
                  <img src={userIcon} />
                  {userName}
                </div>
                <div className="creation_date aligned_text">
                  <img src={calendarIcon} />
                  {getFullDate(design.createdAt)}
                </div>
              </div>
              <div className="horizontal_line_desk"></div>
              <div style={{marginLeft: '0', marginRight: 'auto'}}>
                  <p className="single_des_title_label" style={{textAlign: 'left', margin: '10px 0 0 0'}}>Title:</p>
                  <p className="single_des_title" style={{textAlign: 'left', marginTop: 0}}>{design?.title || noTitle}</p>
                  {design?.comment && 
                  <>
                    <p className="single_des_comment_label" style={{textAlign: 'left', margin: 0}}>Description:</p>
                    <p className="single_des_comment" style={{textAlign: 'left', marginTop: 0}}>{design?.comment}</p>
                  </>
                  }
              </div>
              <div className="image_votes_desk aligned_text">
                <img src={checkIcon} alt="Votes Icon" /> {likes || 0} Votes
              </div>
            </div>
          </div>
          <div className="lower_container">
            <VoteBtn 
                vote={vote} 
                onClickVote={onClickVote} 
                onChangeEmail={onChangeEmail}
                email={email}
                voteBtnState={voteBtnState}
              ></VoteBtn>
            <div style={{ marginTop: "20px" }}>
              <button 
                className="btn_rounded_border_animation" 
                onClick={() => navigate(`/pin/${design.pin_id}/create-design`)}
              >
                <span className="btn_rounded_border_animation_text">Make your own design</span>
              </button>
          
            </div>
            {user?.length > 0 && (
              <Button
                variant="contained"
                color="error"
                sx={{ marginTop: "20px" }}
                onClick={onClickDeleteDesign}
              >
                {deleteBtnText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleDesignDesktop;
